import { ChatIntent } from "./intent.js";
/**
 * More labelled sayings per chat intent for the meaning router (ADR 0042), beyond the few the model prompt shows: the
 * index gets better with every phrasing it has heard, while the prompt must stay short for a small language model.
 * Written as owners speak, in English, Hindi, Kannada and Hinglish. Never copy a case from vectors/intents here: the
 * eval set measures what these sayings generalise to, and would measure nothing if it were in them.
 */
const I = ChatIntent;
export const MORE_SAYINGS = {
    [I.editCard]: [
        "I want to update my card",
        "put my minimum at 600",
        "add Kannada to my languages",
        "I also do AC repair now, add it",
        "मेरा रेट 700 कर दो",
        "मेरे कार्ड में इलाका बदलना है",
        "ನನ್ನ ದರ ಬದಲಾಯಿಸಬೇಕು",
        "ನನ್ನ ಕಾರ್ಡ್‌ನಲ್ಲಿ ಏರಿಯಾ ಬದಲಿಸಿ",
        "mera area HSR kar do",
        "card mein cooking bhi daal do",
    ],
    [I.helpOffer]: [
        "I want to help newcomers to the city",
        "put me down as a mentor",
        "I can guide people who just arrived",
        "नए आए लोगों को रास्ता दिखा सकती हूँ",
        "मुझे मेंटर बनना है",
        "ಹೊಸಬರಿಗೆ ಸಹಾಯ ಮಾಡಲು ಸಿದ್ಧ",
        "naye logon ki help kar sakta hoon",
    ],
    [I.helpStop]: [
        "stop showing me as a mentor",
        "I can't help newcomers now",
        "take me off the helper list",
        "अब नए लोगों की मदद नहीं कर पाऊँगी",
        "मेंटर से हटा दो",
        "ಇನ್ನು ಮುಂದೆ ಹೊಸಬರಿಗೆ ಸಹಾಯ ಬೇಡ",
        "mentor list se hata do",
    ],
    [I.moving]: [
        "I'm shifting to Hyderabad next month for work",
        "I am moving to a new city",
        "planning to relocate to Bengaluru for a job",
        "मैं काम के लिए बैंगलोर जा रही हूँ",
        "अगले महीने दूसरे शहर शिफ्ट हो रहा हूँ",
        "ನಾನು ಕೆಲಸಕ್ಕಾಗಿ ಬೇರೆ ಊರಿಗೆ ಹೋಗುತ್ತಿದ್ದೇನೆ",
        "main naye sheher ja raha hoon kaam ke liye",
    ],
    [I.earnings]: [
        "what did I earn last month",
        "how much money have I made so far",
        "who still owes me money",
        "show my total payments received",
        "इस हफ्ते कितना कमाया",
        "मुझे अब तक कितने पैसे मिले",
        "ಈ ತಿಂಗಳು ಎಷ್ಟು ಸಂಪಾದನೆ ಆಯಿತು",
        "ನನಗೆ ಯಾರು ಇನ್ನೂ ಹಣ ಕೊಡಬೇಕು",
        "mujhe kitna paisa mila is mahine",
    ],
    [I.schedule]: [
        "add a booking on Saturday 11 am to 1 pm",
        "I have work at the Reddy house tomorrow from 4 to 6",
        "am I booked on Thursday?",
        "show me my bookings this week",
        "cancel the booking on Monday morning",
        "सोमवार 10 से 12 बजे का काम लिख लो शेड्यूल में",
        "मेरी इस हफ्ते की बुकिंग दिखाओ",
        "मेरा शेड्यूल दिखाओ, आगे कौन सी बुकिंग हैं",
        "ಸೋಮವಾರ 11 ರಿಂದ 1 ಗಂಟೆ ಬುಕಿಂಗ್ ಸೇರಿಸಿ",
        "ನನ್ನ ಬುಕಿಂಗ್‌ಗಳು ಯಾವುವು",
        "ನನ್ನ ವೇಳಾಪಟ್ಟಿ ತೋರಿಸಿ, ಮುಂದೆ ಯಾವ ಕೆಲಸ ಇದೆ",
        "shanivaar ki booking hata do",
    ],
    [I.market]: [
        "what is the going rate for an electrician",
        "how much do maids charge per month here",
        "is 600 too much for a plumber visit",
        "what should I pay a driver",
        "कुक का रेट क्या है",
        "पेंटर कितना लेते हैं",
        "ಪ್ಲಂಬರ್ ದರ ಎಷ್ಟು",
        "ಮನೆಗೆಲಸಕ್ಕೆ ಎಷ್ಟು ಕೊಡಬೇಕು",
        "electrician ka rate kya hai",
        "maid ko kitna dena chahiye",
    ],
    [I.guide]: [
        "how do I get a bus pass here",
        "where do I register for a ration card",
        "which documents do I need for a rented room",
        "how to open a bank account in the new city",
        "यहाँ किराये का कमरा कैसे मिलेगा",
        "नया सिम कहाँ से लूँ",
        "ಇಲ್ಲಿ ರೂಮ್ ಹೇಗೆ ಹುಡುಕುವುದು",
        "bus pass kaise banega",
    ],
    [I.find]: [
        "I need a plumber today",
        "looking for a cook for my home",
        "can someone come and fix my fan",
        "get me a painter for two rooms",
        "मुझे एक इलेक्ट्रीशियन चाहिए",
        "घर के काम के लिए कोई चाहिए",
        "ನನಗೆ ಒಬ್ಬ ಡ್ರೈವರ್ ಬೇಕು",
        "ಮನೆ ಕ್ಲೀನ್ ಮಾಡಲು ಯಾರಾದರೂ ಬೇಕು",
        "mujhe ek maid chahiye",
        "koi carpenter bhejo",
    ],
    [I.remember]: [
        "note that the Sharma house pays weekly",
        "remember I start at 7 on Mondays",
        "keep a note: bring my own ladder",
        "याद रखो शनिवार को छुट्टी है",
        "नोट कर लो: दूसरी मंज़िल वाले देर से देते हैं",
        "ನೆನಪಿಡಿ ಭಾನುವಾರ ರಜೆ",
        "yaad rakhna Rahul ne advance diya",
    ],
    [I.askSelf]: [
        "what did I note about the Sharma house",
        "did I write anything about Sunday",
        "what was my note on the third floor job",
        "मैंने उस ग्राहक के बारे में क्या लिखा था",
        "ನಾನು ಆ ಮನೆಯ ಬಗ್ಗೆ ಏನು ಬರೆದಿದ್ದೆ",
        "maine kya note kiya tha",
    ],
    [I.askContact]: [
        "ask Meera if she is free tomorrow",
        "where is Raju right now",
        "does Meera know a good plumber",
        "मीरा से पूछो कल आ सकती है क्या",
        "राजू कहाँ है",
        "ಮೀರಾ ನಾಳೆ ಬರ್ತಾರಾ ಕೇಳಿ",
        "Meera se pucho free hai kya",
    ],
    [I.setRule]: [
        "don't let Raju see my location",
        "Meera can ask me anything",
        "stop sharing my schedule with Raju",
        "allow Meera to see my rate",
        "राजू को मेरी जगह मत दिखाओ",
        "मीरा सब देख सकती है",
        "ರಾಜು ಗೆ ನನ್ನ ಜಾಗ ತೋರಿಸಬೇಡ",
        "Raju ko mera schedule mat dikhao",
    ],
    [I.chat]: [
        "good morning",
        "thank you so much",
        "I finished two jobs today",
        "it rained the whole day",
        "my sister got married last week",
        "how are you",
        "नमस्ते",
        "आज बहुत काम था",
        "ಶುಭೋದಯ",
        "ಇವತ್ತು ತುಂಬಾ ಕೆಲಸ ಇತ್ತು",
        "aaj bahut thak gaya",
    ],
};
//# sourceMappingURL=sayings.js.map